import { render, staticRenderFns } from "./BaseTextarea.vue?vue&type=template&id=921f612e&scoped=true&"
import script from "./BaseTextarea.vue?vue&type=script&lang=js&"
export * from "./BaseTextarea.vue?vue&type=script&lang=js&"
import style0 from "./BaseTextarea.vue?vue&type=style&index=0&id=921f612e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "921f612e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\agent\\_work\\11\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('921f612e')) {
      api.createRecord('921f612e', component.options)
    } else {
      api.reload('921f612e', component.options)
    }
    module.hot.accept("./BaseTextarea.vue?vue&type=template&id=921f612e&scoped=true&", function () {
      api.rerender('921f612e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/base/BaseTextarea.vue"
export default component.exports